import { Outlet } from 'react-router-dom';
import Sidebar from '~/modules/myAccount/components/Sidebar';
import ErrorBoundary from '~/components/ErrorBoundary';
import { useGetUserQuery } from '~/redux/api/userApiSlice';
import { useGetUserProfileQuery } from '~/redux/api/authApiSlice';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import Wootric from '~/components/Wootric';
import useBreakpoint from '~/hooks/useBreakpoint';

const MyAccountLayout = () => {
  const { isLoading, isError } = useGetUserQuery();
  const { t, i18n } = useTranslation('app');
  const locale = i18n.language;
  const { mdScreen } = useBreakpoint();
  useGetUserProfileQuery();

  useEffect(() => {
    document.title = `${t('myAccount')}|${t('aqarmap')}`;
  }, []);

  return (
    <ErrorBoundary isError={!isLoading && isError}>
      <div className="layout-boundary flex-1 pt-4x pb-[40px] md:pb-[80px]">
        <div className="layout-boundary__inner px-2x md:px-0">
          <h1 className="text-title_2 font-[600] mb-4x hidden lg:block">
            {t('app:myAccount')}
          </h1>
          <div className="flex lg:gap-5x">
            <div className="hidden lg:block">
              <Sidebar />
            </div>
            <main className="flex-1 relative pb-8x lg:pb-0">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
      {!mdScreen ? <Wootric locale={locale} /> : null}
    </ErrorBoundary>
  );
};

export default MyAccountLayout;
